<script lang="typescript">
  // packages
  import { formatPercent } from '../utils/format-percent';

  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  // props
  export let races: Readable<RaceInterface[]>;
</script>

<table class="stacked-results-table w-full">
  <thead>
    <tr>
      <th scope="col" class="contest__candidate-header">
        District
      </th>
      <th scope="col" colspan="2" class="contest__candidate-header">
        Candidates
      </th>
      <th scope="col" class="contest__candidate-header text-right">Rpt.</th>
    </tr>
  </thead>
  <tbody>
    {#each $races as race (race.id)}
      <tr>
        <th scope="row" class="race_area text-left">{race.seat_number} <span class="district_name">{race.description}</span></th>
        {#each race.candidates as candidate (candidate.ap_id)}
          <td>
            <span class="display-flex justify-between">
              <span class="cand_name">{candidate.family_name}
                {#if candidate.is_incumbent}
                  <span
                    class="candidate__cell-incumbent"
                    title="Currently holds this office">i</span>
                {/if}
                <span class="state_race_party">{candidate.party.toUpperCase()}</span>
              </span>
              <span>{formatPercent(candidate.votes, race.total_votes, 0)}%</span>
            </span>
          </td>
        {/each}
        {#if race.candidates.length < 2}
          <td />
          <td />
        {:else}
          <td class="text-right rpt-num">{race.precincts_reporting_percent}%</td>
        {/if}
      </tr>
    {/each}
  </tbody>
</table>
